/***********
 * 实验教学项目持续建设服务计划
 **************/
import LaborDetailTitleValue from "./LaborDetailTitleValue.vue";
export default {
  components: {
    LaborDetailTitleValue
  },
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    }
  },

  data() {
    return {};
  }

};